import React from 'react';
import Search from './Search';
import AuditItem from './AuditItem'
import { QueryPage } from 'areas/shared/pages/query';
import * as API from 'modules/app/API'
import * as Help from 'modules/app/Help'

class AuditReview extends React.Component {
    render() {
        let opts = {
            title: "Audit Review",
            description: "Search the audit trail",
            helpKey: Help.auditReviewHelpKey,            
            list: {
                url: API.Audit.url('/search'),
                export: API.Audit.url('/export'),
                comp: null,
            }
        };

        return (
            <QueryPage {...opts}
                Search={Search}
                Item={AuditItem}/>
        );
    }
}
export default AuditReview;



// WEBPACK FOOTER //
// ./src/areas/admin/auditReview/AuditReview.js